import { paths as CustomerCommunicationPaths } from '@luxuryescapes/contract-customer-communication';

import { request } from '~/services/common';

import { DestinationAffinityParams, makeDestinationAffinityURL } from './destinationAffinityRequestUtils';

export interface DestinationAffinityCopyParams extends DestinationAffinityParams {
  /** The email's offers to write about, at most 20 */
  offerIds: Array<string>;
}

type DestinationAffinityCopyGetContract =
  CustomerCommunicationPaths['/api/customer-communication/v1/custom-schedules/destination-affinity/copy']['get'];
type DestinationAffinityCopyResponse =
  DestinationAffinityCopyGetContract['responses']['200']['content']['application/json'];

/**
 * The draft is custom schedule fields: the subject line, pre-header, intro text, and article sections at their template
 * positions. The options are alternatives the team could swap in, best first.
 */
export type DestinationAffinityCopyResult = DestinationAffinityCopyResponse['result'];

/**
 * AI-written subject lines, intro copy and articles for the given offers. Waits on the model, so it can take up to ~20s.
 */
async function requestGetDestinationAffinityCopy({ offerIds, ...params }: DestinationAffinityCopyParams) {
  const url = makeDestinationAffinityURL('/copy', params);
  // the contract takes the ids as one comma-separated value
  url.searchParams.set('offerIds', offerIds.join(','));

  const response: DestinationAffinityCopyResponse = await request(url.toString(), {
    method: 'GET',
    credentials: 'include',
  });
  return response.result;
}

export default requestGetDestinationAffinityCopy;
